// Clear Current Page data stored in redux
// This action is fired every time we open a Page for edit
// (It clears previous current page data)
export const clearCurrentPage = (state) => {
  const { loadedPage, pageId, variantId, ...rest } = state;
  return {
    ...rest
  };
};
